import { copy } from 'aws-amplify/storage';

/**
 * Update S3 object metadata to include PostImage ID
 * This enables efficient content moderation database cleanup
 */
export async function updateImageMetadataWithPostImageId(s3Path, postImageId) {
  try {
    // Since Amplify Storage doesn't support metadata updates directly,
    // we need to copy the object to itself with new metadata
    // This is a common pattern for updating S3 metadata

    const result = await copy({
      source: {
        path: s3Path
      },
      destination: {
        path: s3Path
      },
      options: {
        metadataDirective: 'REPLACE',
        metadata: {
          'content-type': 'post-image',
          'post-image-id': postImageId,
          'metadata-updated': Date.now().toString()
        }
      }
    });

    console.log(`Updated metadata for ${s3Path} with PostImage ID: ${postImageId}`);
    return result;

  } catch (error) {
    console.error(`Failed to update metadata for ${s3Path}:`, error);
    // Don't throw - metadata update failure shouldn't break the main flow
    return null;
  }
}

/**
 * Update metadata for multiple image sizes (thumbnail, medium, original)
 */
export async function updatePostImageMetadata(imageUrls, postImageId) {
  const updatePromises = [];

  if (imageUrls.thumbnailUrl) {
    updatePromises.push(updateImageMetadataWithPostImageId(imageUrls.thumbnailUrl, postImageId));
  }

  if (imageUrls.mediumUrl) {
    updatePromises.push(updateImageMetadataWithPostImageId(imageUrls.mediumUrl, postImageId));
  }

  if (imageUrls.originalUrl) {
    updatePromises.push(updateImageMetadataWithPostImageId(imageUrls.originalUrl, postImageId));
  }

  try {
    await Promise.all(updatePromises);
    console.log(`Updated metadata for all image sizes for PostImage: ${postImageId}`);
  } catch (error) {
    console.error(`Some metadata updates failed for PostImage ${postImageId}:`, error);
  }
}